import React, { Component } from "react";
import { Link } from "react-router-dom";

import { scrollToTop } from "./../../helpers/screen";

export default class Clean extends Component {
    componentDidMount() {
        scrollToTop();
    }

    renderNav() {
        const { menu = false } = this.props;

        let renderedNav = [];
        if (menu) {
            const { __back: backLinkText = false, crumbs = [] } = menu;

            if (backLinkText) {
                const { label, to } = backLinkText;
                renderedNav.push(
                    <span key="back-link" className="back-link">
                        <Link to={to}>{label}</Link>
                    </span>,
                );
            }

            if (crumbs && Array.isArray(crumbs)) {
                const crumbsNav = crumbs.map((crumb, crumbIdx) => {
                    const { label, to = false } = crumb;

                    let crumbsNav;
                    if (to) {
                        crumbsNav = (
                            <Link to={to} title={label}>
                                {label}
                            </Link>
                        );
                    } else {
                        crumbsNav = <span>{label}</span>;
                    }

                    return <li key={crumbIdx}>{crumbsNav}</li>;
                });

                if (crumbsNav.length > 0) {
                    renderedNav.push(
                        <ul className="crumbs" key="crumbs">
                            {crumbsNav}
                        </ul>,
                    );
                }
            }
        }

        if (renderedNav.length > 0) {
            renderedNav = <nav className="container-xl">{renderedNav}</nav>;
        } else {
            renderedNav = "";
        }

        return renderedNav;
    }

    render() {
        const { id, children = "", type = false } = this.props;

        return (
            <div id={id} className={`layout-clean ${type}`}>
                <div id="page-top"></div>
                <div className="content-container">
                    {this.renderNav()}
                    {children}
                </div>
            </div>
        );
    }
}
